import React from 'react';
import { useTranslation } from 'react-i18next';
import './ServiceDescription.scss';

const HowItWorksModal = ({ isVisible, onClose, onOutsideClick }) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <div className="overlay" id="how-it-works-popup" onClick={onOutsideClick}>
      <div className="how-it-works-modal">
        <button className="close-btn" onClick={onClose}>×</button>
        
        <div className="service-container howit">
          <h2 className="service-title">{t('howItWorks.title')}</h2>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.introTitle')}</h3>
            <p className="how-body">{t('howItWorks.introBody')}</p>
          </div>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.step1Title')}</h3>
            <p className="how-body">{t('howItWorks.step1Body')}</p>
          </div>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.step2Title')}</h3>
            <p className="how-body">{t('howItWorks.step2Body')}</p>
            <ul className="how-list">
              {(t('howItWorks.step2Bullets', { returnObjects: true }) || []).map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
            <p className="how-short">{t('howItWorks.step2Short')}</p>
          </div>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.step3Title')}</h3>
            <p className="how-body">{t('howItWorks.step3Body')}</p>
          </div>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.step4Title')}</h3>
            <p className="how-body">{t('howItWorks.step4Body')}</p>
          </div>

          <div className="how-section">
            <h3 className="how-title">{t('howItWorks.step5Title')}</h3>
            <p className="how-body">{t('howItWorks.step5Body')}</p>
          </div>

          <div className="how-section summary">
            <h3 className="how-title">{t('howItWorks.summaryTitle')}</h3>
            <p className="how-body">{t('howItWorks.summaryBody')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksModal;
